import React from 'react'
import Collection from '../common/collection'

function CollectionF({ props }) {
  return (
    <Collection
      alt="Niño panal"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/5.1+ni%C3%B1opanal1.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/5.1+ni%C3%B1opanal2.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/5.1+ni%C3%B1opanal3.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/5.1+ni%C3%B1opanal4.jpg',
      ]}
    />
  )
}


export default CollectionF
